<template>
  <div class="c-no-filtered-result">
    <div class="no-filtered-result">
      <img
        :src="
          generateStaticImageUrl('/cdn/Booking.ir/UI/Assets/Img/no-result.png')
        "
        alt="no-filtered-result"
        class="no-filtered-result__img"
      />

      <p class="no-filtered-result__title">موردی یافت نشد</p>

      <button class="btn btn--blue w-100" title="جستجوی مجدد" @click="reLoad">
        جستجوی مجدد
      </button>
    </div>
  </div>
</template>

<script>
import { generateStaticImageUrl } from "@/helpers/tools";
export default {
  methods: {
    generateStaticImageUrl,
    reLoad() {
      document.location.reload(true);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../style/modules/noFilteredResult.scss";
</style>
